import { render, staticRenderFns } from "./Performances.vue?vue&type=template&id=130e2c45&"
import script from "./Performances.vue?vue&type=script&lang=js&"
export * from "./Performances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports